export const pollStyle = (template) => {
  if (template && template.interaction.poll) {
    const obj = template.interaction.poll;
    const placeholder = obj.placeholder;
    const frame = obj.frame;
    const textInput = obj.textInput;
    const sendButton = obj.sendButton;
    const pagination = obj.pagination;
    const questionTitle = obj.questionTitle;
    const buttonOption = obj.buttonOption;
    const boxOption = obj.boxOption;

    return {
      placeholder: {
        iconColor: placeholder.iconColor != "unset" ? placeholder.iconColor : "rgb(90, 96, 227)",
        iconBackgroundColor: placeholder.iconBackgroundColor != "unset" ? placeholder.iconBackgroundColor : "rgb(90, 96, 227, 0.3)",
        color: placeholder.color != "unset" ? placeholder.color : "#222",
        fontWeight: placeholder.fontWeight != "unset" ? placeholder.fontWeight : "500",
        fontFamily: placeholder.fontFamily != "unset" ? placeholder.fontFamily : "Arimo",
        fontSize: "1rem",
      },
      frame: {
        borderColor: frame.borderColor != "unset" ? frame.borderColor : "transparent",
        borderWidth: frame.borderWidth != "unset" ? frame.borderWidth : "0px",
        background: frame.background != "unset" ? frame.background : "#fff",
        borderStyle: "solid",
        borderRadius: frame.borderRadius != "unset" ? frame.borderRadius : "4px",
        boxShadow: "none",
      },
      textInput: {
        background: textInput.background != "unset" ? textInput.background : "#fff",
        fontSize: "1rem",
        color: textInput.color != "unset" ? textInput.color : "#222",
        borderStyle: "solid",
        borderColor: textInput.borderColor != "unset" ? textInput.borderColor : "#eee",
        borderWidth: textInput.borderWidth != "unset" ? textInput.borderWidth : "1px",
        borderRadius: textInput.borderRadius != "unset" ? textInput.borderRadius : "4px",
        fontWeight: textInput.fontWeight != "unset" ? textInput.fontWeight : "500",
        fontFamily: textInput.fontFamily != "unset" ? textInput.fontFamily : "Arimo",
      },
      sendButton: {
        color: sendButton.color != "unset" ? sendButton.color : "rgb(90, 96, 227)",
        background: sendButton.background != "unset" ? sendButton.background : "#fff",
        borderColor: sendButton.borderColor != "unset" ? sendButton.borderColor : "#fff",
        fontWeight: sendButton.fontWeight != "unset" ? sendButton.fontWeight : "500",
        borderStyle: "solid",
        borderWidth: sendButton.borderWidth != "unset" ? sendButton.borderWidth : "0px",
        borderRadius: sendButton.borderRadius != "unset" ? sendButton.borderRadius : "4px",
        fontFamily: sendButton.fontFamily != "unset" ? sendButton.fontFamily : "Arimo",
        fontSize: sendButton.fontSize != "unset" ? sendButton.fontSize : "unset",
      },
      pagination: {
        stepColor: pagination.stepColor != "unset" ? pagination.stepColor : "#222",
        textColor: pagination.textColor != "unset" ? pagination.textColor : "#222",
        fontFamily: pagination.fontFamily != "unset" ? pagination.fontFamily : "Arimo",
      },
      questionTitle: {
        fontSize: questionTitle.fontSize != "unset" ? questionTitle.fontSize : "1rem",
        color: questionTitle.color != "unset" ? questionTitle.color : "#222",
        fontWeight: questionTitle.fontWeight != "unset" ? questionTitle.fontWeight : "500",
        fontFamily: questionTitle.fontFamily != "unset" ? questionTitle.fontFamily : "Arimo",
        textAlign: questionTitle.textAlign != "unset" ? questionTitle.textAlign : "left",
      },
      buttonOption: {
        defaultBorderColor: buttonOption.defaultBorderColor != "unset" ? buttonOption.defaultBorderColor : "rgb(90, 96, 227)",
        defaultTextColor: buttonOption.defaultTextColor != "unset" ? buttonOption.defaultTextColor : "rgb(90, 96, 227)",
        defaultBackgroundColor: buttonOption.defaultBackgroundColor != "unset" ? buttonOption.defaultBackgroundColor : "#fff",
        checkedBorderColor: buttonOption.checkedBorderColor != "unset" ? buttonOption.checkedBorderColor : "rgb(90, 96, 227)",
        checkedTextColor: buttonOption.checkedTextColor != "unset" ? buttonOption.checkedTextColor : "#fff",
        borderStyle: "solid",
        checkedBackgroundColor: buttonOption.checkedBackgroundColor != "unset" ? buttonOption.checkedBackgroundColor : "rgb(90, 96, 227)",
        borderRadius: buttonOption.borderRadius != "unset" ? buttonOption.borderRadius : "4px",
        borderWidth: "1px",
        fontSize: buttonOption.fontSize != "unset" ? buttonOption.fontSize : "1rem",
        fontFamily: buttonOption.fontFamily != "unset" ? buttonOption.fontFamily : "Arimo",
        fontWeight: buttonOption.fontWeight != "unset" ? buttonOption.fontWeight : "500",
        margin: buttonOption.margin != "unset" ? buttonOption.margin : "5px",
      },
      boxOption: {
        checkedColor: boxOption.checkedColor != "unset" ? boxOption.checkedColor : "rgb(90, 96, 227)",
        uncheckedColor: boxOption.uncheckedColor != "unset" ? boxOption.uncheckedColor : "gray",
      },
    };
  } else {
    return {
      placeholder: {
        iconColor: "rgb(90, 96, 227)",
        iconBackgroundColor: "rgb(90, 96, 227, 0.3)",
        color: "#222",
        fontWeight: "500",
        fontFamily: "Arimo",
        fontSize: "1rem",
      },
      frame: {
        borderColor: "transparent",
        borderWidth: "0px",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "none",
      },
      textInput: {
        background: "#eee",
        fontSize: "1rem",
        color: "#222",
        borderColor: "rgb(90, 96, 227)",
        borderWidth: "0px",
        borderRadius: "4px",
        fontWeight: "500",
        fontFamily: "Arimo",
      },
      sendButton: {
        color: "rgb(90, 96, 227)",
        background: "#fff",
        borderColor: "#fff",
        fontWeight: "500",
        borderWidth: "0px",
        borderRadius: "4px",
        fontFamily: "Arimo",
      },
      pagination: {
        stepColor: "#222",
        textColor: "#222",
      },
      questionTitle: {
        fontSize: "1rem",
        color: "rgb(90, 96, 227)",
        fontWeight: "bold",
        fontFamily: "Arimo",
        textAlign: "left",
      },
      buttonOption: {
        defaultBorderColor: "rgb(90, 96, 227)",
        defaultTextColor: "rgb(90, 96, 227)",
        defaultBackgroundColor: "#fff",
        checkedBorderColor: "rgb(90, 96, 227)",
        checkedTextColor: "#fff",
        checkedBackgroundColor: "rgb(90, 96, 227)",
        borderRadius: "4px",
        borderWidth: "1px",
        fontFamily: "Arimo",
        fontWeight: "500",
      },
      boxOption: {
        checkedColor: "rgb(90, 96, 227)",
        uncheckedColor: "rgb(90, 96, 227)",
      },
    };
  }
};
